/*eslint-disable no-unused-vars */
import { axiosInstance } from '../../../api/axios';
//import axiosInstanceWithTimeout from '../../../api/axiosWithTimeout';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Member/api/APIEndpoints'; //getNetworksList
import { doctorDetails } from '../../../Member/components/find-provider/data/schema-mock-data';

export const getNetworksList = createAsyncThunk(
  'getNetworksListPC',
  async (params, { getState }) => {
    const apiUrl = APIEndpoints.getNetworksList();
    const response = await axiosInstance.get(apiUrl);
    return response;
  },
);

export const getHealthProcedureCodes = createAsyncThunk(
  'getHealthProcedureCodes',
  async (params, { getState }) => {
    const apiUrl = APIEndpoints.getHealthProcedureCodes();
    const response = await axiosInstance.get(apiUrl);
    return response;
  },
);

/**
 * @method
 */
const prepareSearchParamsUrl = (params) => {
  console.log('params', params);
  return new Promise((resolve, reject) => {
    let searchParams = '';
    Object.keys(params).forEach((key, index) => {
      if (params[key]) {
        if (typeof params[key] === 'object') {
          if (Array.isArray(params[key])) {
            if (params[key].length > 0) {
              const keyValues = params[key].join(',');
              searchParams += `/${key}/${keyValues}`;
            }
          } else {
            let objectData = '';
            Object.keys(params[key]).forEach((nestedKey) => {
              objectData += `${params[key][nestedKey]},`;
            });
            searchParams += `/${key}/${objectData.slice(0, -1)}`;
          }
        } else {
          searchParams += `/${key}/${params[key]}`;
        }
        //&& searchParams.includes('maximumradius') === false
        if (Object.keys(params).length - 1 === index) {
          //searchParams += `/maximumradius/${params?.maximumradius || MAXIMUM_FIND_PROVIDER_RADIUS}`
          resolve(searchParams);
        }
      }
    });
  });
};

export const searchProvidersPC = createAsyncThunk(
  'searchProvidersPC',
  async (params, { getState, dispatch }) => {
    const {
      searchParamsForUI: { procedureForData },
      searchProviderParams: { filters, selectedNetwork, ...searchParams },
      address: UserAddress,
      providerType,
      searchResults,
    } = getState().priceCompare;

    const allSearchParams = {
      ...params,
      ...filters,
      ...searchParams,
      UserAddress,
    };
    if (params?.pagenumber) {
      allSearchParams.pagenumber = params.pagenumber;
    }
    if (selectedNetwork?.ProviderDirectory === 'R') {
      if (searchParams?.pagenumber > 4) {
        if (!searchResults?.data) {
          allSearchParams.pagesize = 10 * searchParams?.pagenumber;
        }
      } else {
        allSearchParams.pagesize = 40;
      }
      if (!searchResults?.data) {
        allSearchParams.pagenumber = 1;
      }
    }
    let apiUrl = '';
    allSearchParams?.Provider === 'facility'
      ? (apiUrl = APIEndpoints.searchFacilitiesUpgraded())
      : (apiUrl = APIEndpoints.searchDoctorsUpgraded());

    const {
      sortby,
      sortdirection,
      specialities,
      DoctorByType,
      FacilityByType,
      ...restOfParams
    } = allSearchParams;

    if (allSearchParams?.Provider === 'doctor') {
      const DoctorByTypeValues =
        specialities && DoctorByType
          ? [...specialities]
          : specialities
          ? specialities
          : DoctorByType
          ? [DoctorByType]
          : [];
      if (DoctorByTypeValues?.length > 0)
        allSearchParams.DoctorByType = [...DoctorByTypeValues];
      console.log('allSearchParams', allSearchParams);
    }
    if (allSearchParams?.Provider === 'facility') {
      const FacilityByTypeValues =
        specialities && FacilityByType
          ? [FacilityByType, ...specialities]
          : specialities
          ? specialities
          : FacilityByType
          ? [FacilityByType]
          : [];
      if (FacilityByTypeValues?.length > 0)
        allSearchParams.FacilityByType = [...FacilityByTypeValues];
    }
    const paramsUrl = await prepareSearchParamsUrl(allSearchParams);

    let memberDetails = '';
    if (procedureForData?.memberType) {
      memberDetails += `/membertype/${procedureForData?.memberType}`;
    }
    if (procedureForData?.value) {
      memberDetails += `/memberoid/${procedureForData?.value}`;
    }
    const finalApiUrl =
      apiUrl +
      paramsUrl +
      memberDetails +
      (selectedNetwork?.ProviderDirectory
        ? `/cignaprovider/${selectedNetwork?.ProviderDirectory}`
        : '') +
      (allSearchParams?.Provider === 'facility' ? '' : '/filterdata/false');
    console.log('finalApiUrl AcceptingNewPatients', finalApiUrl);
    const response = await axiosInstance.get(finalApiUrl);
    response.data.Response.data =
      allSearchParams?.Provider === 'facility'
        ? response?.data?.Response?.FacilityResponse || []
        : response?.data?.Response?.SearchDoctors || [];
    response.isCignaRoasterSearch = selectedNetwork?.ProviderDirectory === 'R';
    response.searchParamsPageNumber = params?.pagenumber; //this pagenumber param is passed for offset for cigna roaster searches
    return response;
  },
);

/**
 * @method: getPriceComaperFilters
 */
export const getPriceComaperFilters = createAsyncThunk(
  'getPriceComaperFilters',
  async (params, { getState }) => {
    const {
      searchParamsForUI: { procedureForData },
      searchProviderParams: { filters, selectedNetwork, ...searchParams },
      address: UserAddress,
      //usercoordinates: userCoordinates,
      providerType,
    } = getState().priceCompare;

    const allSearchParams = {
      ...params,
      ...filters,
      ...searchParams,
      UserAddress,
    };

    //let apiUrl = APIEndpoints.getDoctorFiltersList();
    //let apiUrl = APIEndpoints.searchDoctors();
    //if (providerType === 'facility') {
    //apiUrl = APIEndpoints.getFacilityFiltersList();
    //}
    let apiUrl = '';
    allSearchParams?.Provider === 'facility'
      ? (apiUrl = APIEndpoints.searchFacilitiesUpgraded())
      : (apiUrl = APIEndpoints.searchDoctorsUpgraded());
    const {
      sortby,
      sortdirection,
      specialities,
      DoctorByType,
      FacilityByType,
      ...restOfParams
    } = allSearchParams;

    if (allSearchParams?.Provider === 'doctor') {
      const DoctorByTypeValues =
        specialities && DoctorByType
          ? [...specialities]
          : specialities
          ? specialities
          : DoctorByType
          ? [DoctorByType]
          : [];
      if (DoctorByTypeValues?.length > 0)
        restOfParams.DoctorByType = [...DoctorByTypeValues];
    }
    if (allSearchParams?.Provider === 'facility') {
      const FacilityByTypeValues =
        specialities && FacilityByType
          ? [FacilityByType, ...specialities]
          : specialities
          ? specialities
          : FacilityByType
          ? [FacilityByType]
          : [];
      if (FacilityByTypeValues?.length > 0)
        restOfParams.FacilityByType = [...FacilityByTypeValues];
    }
    restOfParams.pagesize = 100;
    restOfParams.pagenumber = 1;

    const paramsUrl = await prepareSearchParamsUrl(restOfParams);

    let memberDetails = '';
    if (procedureForData?.memberType) {
      memberDetails += `/membertype/${procedureForData?.memberType}`;
    }
    if (procedureForData?.value) {
      memberDetails += `/memberoid/${procedureForData?.value}`;
    }
    const finalApiUrl =
      apiUrl +
      paramsUrl +
      memberDetails +
      (selectedNetwork?.ProviderDirectory
        ? `/cignaprovider/${selectedNetwork?.ProviderDirectory}`
        : '') +
      (allSearchParams?.Provider === 'facility' ? '' : '/filterdata/true');
    const response = await axiosInstance.get(finalApiUrl);
    return response;
  },
);

export const getDoctorDetails = createAsyncThunk(
  'getDoctorDetails',
  async (params, { getState }) => {
    //"OID", // from params
    //"Network": //from state,
    //"UserCoordinates": //from state
    const {
      searchProviderParams: { Network, UserCoordinates },
    } = getState().priceCompare;
    const allParams = { ...params };
    if (Network) {
      allParams.Network = Network;
    }
    if (UserCoordinates) {
      allParams.UserCoordinates = UserCoordinates;
    }
    return doctorDetails;
  },
);
